import * as globals from '@wandb/weave/common/css/globals.styles';
// @todo: Migrate to 'Link' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Link} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import WBReactTable from '../../WBReactTable';

export const LoaderWrapper = styled.div`
  position: relative;
  height: 400px;
`;

export const InfoLink = styled(Link)`
  && {
    // WBReact's 'a' tag uses !important so we need to overwrite :(
    color: ${globals.TEAL_500} !important;
  }
`;

export const TeamMembersTable = styled(WBReactTable)`
  .rt-td {
    overflow: visible;
  }

  overflow: visible;
`;
